import { create } from 'zustand';

interface chatState {
    chat: boolean;
    toggleChat: (value?: boolean) => void;
    mini: boolean;
    minimize: () => void;
    sendFrom: number;
    setSendFrom: (id: number) => void;
}

export const chatStore = create<chatState>((set) => ({
    chat: false,
    mini: false,
    sendFrom: 0,
    toggleChat: (value?: boolean) => {
        set((state) => ({ chat: value != undefined ? value : !state.chat }));
    },
    minimize: () => {
        set((state) => ({ mini: !state.mini }));
    },
    setSendFrom: (id: number) => {
        set(() => ({ sendFrom: id }));
    },
}));
